import $ from 'jquery';

import BillingForm from './BillingForm';

// Shipping Options.
const SEND_TO_SAVED = '0';
const SEND_TO_CUSTOM = '1';
const SEND_TO_STORE = '2';


class ShippingForm extends BillingForm {

	constructor( selector ) {

		super( selector );

		// Set Initial Sending Option.
		this.sendingOption = this.getSendingOption();
		this.formEl.addEventListener( 'change', ( ev ) => {
			if ( ev.target.matches( '.shipping_option' ) ) {
				this.changeSendingOption();
			}
		} );
	}

	/**
	 * validate the whole form, asynchronously
	 * @return Promise A promise, that resolves to true, if the form is valid.
	 */
	validateForm() {

		switch ( this.sendingOption ) {

			// Validate Input value - should not do anything.
			case SEND_TO_SAVED:
				return this.validateFields();

			// Validate whole form.
			case SEND_TO_CUSTOM:
				return super.validateForm();

			// Validate Input value - should not do anything.
			case SEND_TO_STORE:
				return this.validateFields();
		}

		return true;
	};

	getSendingOption() {
		const inputEl = this.formEl.querySelector( '.shipping_option:checked' );
		return inputEl?.value;
	};

	changeSendingOption() {
		const sendingOption = this.getSendingOption();
		this.updateSendingOption( sendingOption );
		return sendingOption;
	};

	updateSendingOption( option ) {
		this.sendingOption = option;
		return fetch( '/index.php?cl=user&fnc=checkPreferedFlag', {
			method: 'POST',
			body: new URLSearchParams( { option } )
		} );
	};

	static initForms = ( elementList ) => {
		return Array.from( elementList ).forEach( function( formEl ) {
			formEl.ACL_SHIPPING_FORM ??= new ShippingForm( formEl );
		} );
	}
};

$( document ).ready( function() {

	// Shipping Forms.
	const shippingFormEls = document.querySelectorAll( '#userform, .update-form-shipping, .update-form-billing' );
	ShippingForm.initForms( shippingFormEls );
} );

// Export Form Class.
export default ShippingForm;
